export default {
      id: "read-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "sprite.svg#read",
      toString: function () {
        return this.url;
      }
    }